import React, { useState } from "react";
import "./reviewCard.css";
import { ReadMoreButton } from "../Buttons/ReadMoreButton/ReadMoreButton";

export default function ReviewCard({ name, rating, date, reviewText }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const wordLimit = 30;

  const truncateText = (text, limit) => {
    const words = text.split(" ");
    return words.length > limit
      ? words.slice(0, limit).join(" ") + "..."
      : text;
  };
  const handleClick = () => {
    setIsExpanded(!isExpanded);
  };

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <svg
        key={index}
        fill={index < rating ? "#f9c50b" : "#e0e0e0"}
        width="18px"
        height="18px"
        viewBox="0 0 1920.00 1920.00"
        xmlns="http://www.w3.org/2000/svg"
        stroke={index < rating ? "#f9c50b" : "#e0e0e0"}
        strokeWidth="0.019200000000000002"
      >
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          {" "}
          <path
            d="M1915.918 737.475c-10.955-33.543-42.014-56.131-77.364-56.131h-612.029l-189.063-582.1v-.112C1026.394 65.588 995.335 43 959.984 43c-35.237 0-66.41 22.588-77.365 56.245L693.443 681.344H81.415c-35.35 0-66.41 22.588-77.365 56.131-10.955 33.544.79 70.137 29.478 91.03l495.247 359.831-189.177 582.212c-10.955 33.657 1.13 70.25 29.817 90.918 14.23 10.278 30.946 15.487 47.66 15.487 16.716 0 33.432-5.21 47.775-15.6l495.134-359.718 495.021 359.718c28.574 20.781 67.087 20.781 95.662.113 28.687-20.668 40.658-57.261 29.703-91.03l-189.176-582.1 495.36-359.83c28.574-20.894 40.433-57.487 29.364-91.03"
            fillRule="evenodd"
          ></path>{" "}
        </g>
      </svg>
    ));
  };
  return (
    <article className="review-card">
      <div>
        <div className="review-card-quote-mark">
          <svg
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            id="quote_mark"
            data-name="quote mark"
            xmlns="http://www.w3.org/2000/svg"
            fill="#000000"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              {" "}
              <rect
                id="Rectangle_3"
                data-name="Rectangle 3"
                width="24"
                height="24"
                fill="none"
              ></rect>{" "}
              <path
                id="Rectangle"
                d="M0,3A3,3,0,0,1,3,0H5A3,3,0,0,1,8,3V4c0,6-2.028,10-7,10,4-3.962,3-6,3-6H3A3,3,0,0,1,0,5Z"
                transform="translate(2 5)"
                fill="none"
                stroke="#4e8157"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.5"
              ></path>{" "}
              <path
                id="Rectangle-2"
                data-name="Rectangle"
                d="M0,3A3,3,0,0,1,3,0H5A3,3,0,0,1,8,3V4c0,6-2.028,10-7,10,4-3.962,3-6,3-6H3A3,3,0,0,1,0,5Z"
                transform="translate(14 5)"
                fill="none"
                stroke="#4e8157"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.5"
              ></path>{" "}
            </g>
          </svg>
        </div>
        <div className="review-card-text">
          <p>{isExpanded ? reviewText : truncateText(reviewText, wordLimit)}</p>
          {reviewText.split(" ").length > wordLimit && (
            <ReadMoreButton isExpanded={isExpanded} onToggle={handleClick} />
          )}
        </div>
      </div>
      <div className="review-card-information">
        <div className="review-card-information-img">
          <p>{name?.charAt(0).toUpperCase()}</p>
        </div>
        <div className="review-card-information-text">
          <p>{name}</p>
          <div className="review-card-information-review">
            <div className="review-card-information-stars">
              {renderStars(rating)}
            </div>
            {/* <p>{date}</p> */}
          </div>
        </div>
      </div>
    </article>
  );
}
